import { FC, useCallback } from "react";
import { StyleProp, StyleSheet, TextInput, View, ViewStyle } from "react-native";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { SearchIcon } from "./impComponents/SearchIcon";

type search = {
  placeholder?: string;
  viewStyle?: StyleProp<ViewStyle>;
};

const Search: FC<search> = ({ placeholder: myPlaceholder, viewStyle }) => {
  const rSearchData = useSelector(({ SearchReducer }) => SearchReducer.rSearchData);
  const dispatch = useAppDispatch();

  const changeMessageSearch = useCallback(
    (mySearchText: string) => {
      dispatch({
        type: "UPDATE_SEARCH",
        rSearchData: {
          ...rSearchData,
          messageData: {
            ...rSearchData.orderData,
            currentSearch: mySearchText.toLowerCase(),
          },
        },
      });
    },
    [dispatch, rSearchData],
  );
  return (
    <View style={[styles.gSearchContainer, viewStyle]}>
      <SearchIcon />
      <TextInput
        onChangeText={changeMessageSearch}
        placeholder={myPlaceholder ?? "Search"}
        style={styles.gTopButtonsTextInput}
      />
    </View>
  );
};

export default Search;

const styles = StyleSheet.create({
  gSearchContainer: {
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 2,
    flexDirection: "row",
    marginVertical: 6 * kStyleConst.kSpacing,
    paddingBottom: kStyleConst.kSpacing,
    width: kStyleConst.kSearchContainerWidth,
  },
  gTopButtonsTextInput: {
    marginLeft: 2 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingBottom: 2,
  },
});
